// extracted by mini-css-extract-plugin
export default {"ac-card":"eQ6dhe8RmKZpKvowCxAD"};